<template>
  <div :style="{ height: layoutPageHeight + 'px' }">
    <div class="row1" :style="{ height: row1Height + 'px' }">
      <div class="d-flex">
        <span class="font-bold mr10">标签名称：</span>
        <el-select
          class="input200 mr10 custom-input"
          filterable
          remote
          :remote-method="getTagTemplates"
          @focus="getTagTemplates()"
          @change="templateChange"
          v-model="templateId"
        >
          <el-option
            v-for="item in templateOpts"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <p class=" mr10">标签尺寸:</p>
        <span class="value-item  mr10">{{  sizeRemark ? `${sizeRemark} mm` : `${size} pixel` }}</span>
        <div class=" mr10">标签总数： {{printSum}}</div>
        <el-button @click="handleAddData">添加标签</el-button>
        <el-button @click="saveAndPrint">打印标签</el-button>
      </div>
      <div class="model-title">公用信息：</div>
      <div class="line"></div>
      <div class="public-box">
        <keys
          v-show="tagContentPublic.length"
          class="mr20"
          ref="publicKey"
          :mode="'edit'"
          :in-list="tagContentPublic"
          :item-index="itemIndex"
          @toggleActiveKey="toggleActiveKey"
          :isPublic='true'
          @modifySon="modifySon"
          :key="templateId"
        />
        <div class="d-flex vertical top back-color mr20">
          <p class="required">打印人:</p>
          <el-autocomplete
            v-model="printUserName"
            class="input200"
            :fetch-suggestions="(query, cb) => {
              getUserOpts(query, cb)
            }"
            :placeholder="`请输入`"
            value-key="name"
            @select="userSelectChange"
            @input="userSelectInput"
            clearable
          ></el-autocomplete>
        </div>
      </div>
      <div class="model-title">个性信息：</div>
      <div class="line"></div>
    </div>
    <div class="row2" :style="{ height: (layoutPageHeight - row1Height) + 'px' }">
      <div class="box">
        <div v-for="(item,index) in allTagContent" :key="item.key">
          <div class="box-item">
            <div class="row2-1">
              <div class="print-box">
                <span class="mr20">打印数量</span>
                <el-input-number class="mr20" v-model="item.printNum" @change="handleChange" :min="1" :max="100"></el-input-number>
                <i class="el-icon-remove-outline icon" @click="deletePackage(index)" v-if="index != 0"></i>
              </div>
              <keys
                :ref="'ref'+index"
                :mode="'edit'"
                :in-list="item.data"
                :item-index="index"
                @toggleActiveKey="toggleActiveKey"
                :isPublic='false'
              />
            </div>
            <div class="row2-2">
              <designer
                :ref="`designer-${index}`"
                :mode="'edit'"
                :in-list="tagContentPublic.concat(item.data,tagContentText)"
                :size="designerSize"
                :active-key="activeKey"
              />
            </div>
          </div>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Keys from '../components/keys.vue'
import tagMixin from '@/mixins/tag'
import KeysMixin from '../mixins/keys'
import Designer from '../components/designer.vue'
import {
  userOptions,
  getTag,
  saveMultiple,
  getLastPrint,
  getPackageDetail
} from '@/api.js'
export default {
  name: 'TagTemplateEdit',
  mixins: [ tagMixin, KeysMixin ],
  components: {
    Keys,
    Designer
  },
  data() {
    return {
      layoutPageHeight:0,
      row1Height:240,
      name: '',
      size: '',
      sizeRemark: '', // 尺寸备注
      inList: [],
      itemIndex: 0,
      designerSize: undefined,
      activeKey: '',
      printUser: undefined,
      printUserName: undefined,
      userOpts: [],
      templateOpts: [],
      templateId: undefined,
      templateDetail: null,
      inListArr:[],
      tagContentPublic:[], // 模板中的公共内容
      tagContentInde:[], // 模板中的独立内容
      allTagContent:[], //模板中所有的内容
      printSum:1,
      tagContentText:[], //模板中的：标签显示文本等
      templateRecordDetail: null, // 模板的打印机记录
    }
  },
  computed: {
    ...mapGetters([ 'user' ])
  },
  methods: {
    // 修改子组件
    modifySon(item){
      let model = this.$refs['publicKey'].model
      for(let i=0;i<this.allTagContent.length;i++){
        let ref = 'ref' + i
        this.$refs[ref][0].pulickModify(item,model);
      }
    },
    sizeChange() {
      // 标签工具尺寸切换
      const size = this.size.toLowerCase()
      const sizeArray = size.split('x').map(i => i.trim())
      const width = sizeArray[0] ? Number(sizeArray[0]) : 500
      const height = sizeArray[1] ? Number(sizeArray[1]) : 300
      const sizeConfig = {
        width,
        height,
        scale: 1
      }

      this.designerSize = sizeConfig
    },
    templateChange(value) {
      // 标签模板切换
      this.$nextTick(() => {
        const dom = this.$el.querySelector('.el-input__inner');
        if (dom) {
          dom.title = value ? this.templateOpts.find(i => i.id === value).name : ''
        }

        dom.blur()
      });

      this.getDetail(this.templateId)
    },
    async getDetail(id) {
      // 获取详情
      this.reset()
      this.templateId = Number(id)
      const detail = await this._getSmartTagDetail(id)
      
      if (detail) {
        this.templateDetail = detail
        const { content, size, name, tenant_id, size_alias } = detail
        this.size = size
        this.sizeRemark = size_alias
        this.name = name
        this.sizeChange()

        try {
          let tagContent = JSON.parse(content || '[]')
          if (this.$utils.checkType(tagContent) !== 'array') {
            this.$message.error(`标签内容解析出错`)
            return
          }
          
          tagContent = await this._setLogoByData(tagContent, tenant_id)

          this.inList = tagContent
          this.labelList()
          this.renderKeys()
          // this.allTagContent.push(JSON.parse(JSON.stringify(this.tagContentInde)))
          this.addData()
          // this.getLastPrintRecord()
          this.calcItemIndex(this.inList.length)
        } catch (error) {
          console.error('解析标签数据格式出错')
        }
      }
    },
    async handlePrintRecordData(data) {
      // 处理数据内容，防止为0的字段影响select框显示等问题
      const copy = JSON.parse(JSON.stringify(data))
      
      for (const key in copy) {
        if (Object.prototype.hasOwnProperty.call(copy, key)) {
          const value = copy[key]
          if (value === 0) {
            delete(copy[key])
          }
        }
      }

      if (copy.instrumentset_id) {
        copy.instruments = await this.getInstrumentsData(copy.instrumentset_id)
      }

      return copy
    },
    getInstrumentsData(instrumentset_id) {
      // 插入器械明细数据
      const url = getPackageDetail.replace('{id}', instrumentset_id)
      return this.$request('get', url)
      .then(res => {
        if (res) {
          const {
            instrument
          } = res

          return instrument.map(i => {
            return {
              name: i.name,
              number: i.number
            }
          })
        }
      })
    },
    getLastPrintRecord() {
      // 获取上次打印记录并设置到字段中
      return this.$request('get', getLastPrint, {
        tag_id: this.templateId
      }).then(async (res) => {
        if (res && Object.keys(res)) {
          // 将获取到的内容设置到模板字段中
          this.templateRecordDetail = await this.handlePrintRecordData(res)
          this.setPrintRecordIntoTagKeys()
        }
      })
    },
    convertDateTimeDataText(value, type) {
      // 将日期时间类型的数据按照类型转换为对应的字符串
      const dateArray = value.split(' ')
      let text = ''
      if (type === 'date') {
        text = dateArray[0] || ''
      } else if (type === 'time') {
        text = dateArray[1] || ''
      } else if (type === 'datetime') {
        text = value
      }

      return text
    },
    setPrintRecordIntoTagKeys() {
      // 将模板上次打印记录设置到模板字段中
      const lastRefIndex = this.allTagContent.length - 1
      const lastRefInstance = this.$refs[`ref${lastRefIndex}`][0]
      const lastDisgnerInstance = this.$refs[`designer-${lastRefIndex}`][0]

      if (lastRefInstance) {
        const { inList } = lastRefInstance

        inList.forEach(i => {
          const { key } = i
          const textKey = this.matchTextKey(key)

          if (Object.hasOwnProperty.call(this.templateRecordDetail, key)) {
            const value = this.templateRecordDetail[key]
            this.$set(lastRefInstance.model, key, value)
            this.asyncValueAndTextIntoKeysComponent(lastRefInstance, key, value)
            this.asyncValueAndTextIntoDesignerComponent(lastDisgnerInstance, key, value, 'value')

            if (this.dateTimeTypes.map(d => d.key).includes(i.type)) {
              // 如果该字段是日期时间类型
              const dateTimeText = this.convertDateTimeDataText(value, i.type)
              this.asyncValueAndTextIntoDesignerComponent(lastDisgnerInstance, key, dateTimeText, 'text')
            }
          }

          if (textKey && Object.hasOwnProperty.call(this.templateRecordDetail, textKey)) {
            const value = this.templateRecordDetail[textKey]
            this.$set(lastRefInstance.model, textKey, value)
            this.asyncValueAndTextIntoKeysComponent(lastRefInstance, textKey, value)
            this.asyncValueAndTextIntoDesignerComponent(lastDisgnerInstance, key, value, 'text')
          }
        })
      }
    },
    matchTextKey(apiKey) {
      // 通过接口提交的数据数值字段名对应匹配文本字段名
      const item = this.keys.find(i => i.apiKey === apiKey)
      if (item) {
        return item.apiTextKey
      }

      return ''
    },
    getDictData(type) {
      // 获取字典数据（用于将接口记录的值value匹配出字典中的text），临时修复bug，未来开发时，此处需要修改，text直接由接口记录，则此处逻辑可以取消
      return this.$utils.getDict([type])
      .then(res => {
        return res[type]
      })
    },
    async asyncValueAndTextIntoDesignerComponent(instance, key, value, type = 'text') {
      // 将记录数据同步到keys组件中，用于展示
      const dictKeys = [
        {
          key: 'pack_option',
          type: 5
        },
        {
          key: 'instrumentset_type',
          type: 314
        }
      ]
      const item = dictKeys.find(i => i.key === key)
      let dictText;
      if (item) {
        const options = await this.getDictData(item.type)
        const dictItem = options.find(i => i.value === value)
        dictText = dictItem ? dictItem.name : ''
      }

      instance.inList.forEach(i => {
        if (key === i.key) {
          if (dictText) {
            this.$set(i, 'text', dictText)
          }

          if (type === 'text') {
            this.$set(i, 'text', value)
          } else if (type === 'value') {
            this.$set(i, 'value', value)
            if (i.type === 'list') {
              this.$set(i, 'list', value)
            }
          }
        }
      })
    },
    asyncValueAndTextIntoKeysComponent(instance, key, value) {
      // 将记录数据同步到keys组件中，用于展示
      instance.renderKeys.forEach(i => {
        if (i.apiKey === key && value) { // 如果是0也会被过滤
          this.$set(i, 'value', value)
          this.$set(i, i.apiKey, value)
        } else if (i.apiTextKey === key) {
          this.$set(i, 'text', value)
        }
      })
    },
    // 筛选出：标签显示文本和logo等
    labelList(){
      let key = this.allKeys.map((i) => Object.assign({}, i));
      let allApiKeys = key.map((i) => i.apiKey)
      this.tagContentText = this.inList.filter((i) => !(allApiKeys.includes(i.key)) || i.type == 'serial_number' || i.type == 'logo')
    },
    // 删除包
    deletePackage(index) {
      this.allTagContent.splice(index, 1);
      this.handleChange()
      this.$message.success(`删除成功`);
    },
    // 在allkey中区分公共字段和独立字段
    renderKeys(){
      let keys = [];
      this.keys = this.allKeys.map((i) => Object.assign({}, i));
      keys = this.keys.filter((i) => i.methodType !== 'logo' && i.methodType !== 'serial_number') // 编辑打印时暂时隐藏logo字段、流水号字段 
      .filter((i) => this.inList.map((i) => i.key).includes(i.apiKey))
      .map((i)=>{
        const item = this.inList.filter(l => l.key === i.apiKey)
        if(i.isPublic){// 公共内容
          this.tagContentPublic = [...this.tagContentPublic,...item]
        }else{ // 单独内容内容
          this.tagContentInde = [...this.tagContentInde,...item]
        }
      })
    },
    // 点击添加按钮
    handleAddData() {
      this.addData()
      // this.getLastPrintRecord()
    },
    addData(){
      if(!this.templateId){
        this.$message.warning(`请先选择标签模板`)
        return
      }
      this.handleChange()  // 计算标签打印的总数
      let newData = { 
        printNum:1,
        data:JSON.parse(JSON.stringify(this.tagContentInde))
      }
      this.allTagContent.push(newData)

      // 如果公共标签信息已经有值，需要对新添加的子元素进行赋值
      this.$nextTick(()=>{
        let publicKey = this.$refs['publicKey'].model
        let ref = `ref`+ (this.allTagContent.length - 1)
        this.$refs[ref][0].model = JSON.parse(JSON.stringify(publicKey))
      })
    },
    // 重置数据
    reset() {
      this.inList = []
      this.designerSize = undefined
      this.itemIndex = 0
      this.tagContentPublic = [] // 模板中的公共内容
      this.tagContentInde = [] // 模板中的独立内容
      this.allTagContent = [] //模板中所有的内容
    },
    calcItemIndex(index = 0) {
      // 计算已添加元素的index，防止重复
      const indexes = this.inList.map(i => i.id).map(i => i.split('-')[0])
      const result = index + 1
      if (indexes.includes(`${result}`)) {
        return this.calcItemIndex(result)
      } else {
        return result 
      }
    },
    async init() {
      const { id } = this.$route.params
      if (id && Number(id)) {
        await this.getTagTemplates()
        this.getDetail(id)
      }
      await this.getUserOpts()
      if (this.userOpts && this.userOpts.length && this.userOpts.map(i => i.id).includes(this.user.id)) {
        this.printUser = this.user.id
        this.printUserName = this.user.name
      }
    },
    toggleActiveKey(activeKey) {
      this.activeKey = activeKey
    },
    getData(data){
      this.inListArr = data
    },
    getUserOpts(name = undefined, cb) {
      const url = userOptions.replace('{type}', 0)
      return this.$request('get', url, { name } ).then((res) => {
        this.userOpts = res
        
        if (cb) {
          cb(res)
        }
      })
    },
    userSelectChange(item) {
      const {
        id,
        name
      } = item
      this.printUser = id
      this.printUserName = name
    },
    userSelectInput() {
      this.printUser = undefined
    },
    requiredValidate(){
      let arr = []
      arr = arr.concat(this.requiredValidateItem(this.tagContentPublic))
      this.allTagContent.forEach((item)=>{
        arr = arr.concat(this.requiredValidateItem(item.data))
      })

      if (!this.printUser && !this.printUserName.trim()) {
        arr.push(`打印人`)
      }

      const uniqueArray = Array.from(new Set(arr))
      if (uniqueArray.length) {
        this.$message.error(`${uniqueArray.join('、')}是必填的`)
      }

      return arr.length > 0
    },
    requiredValidateItem(data) {
      // 必填校验
      const requiredKeys = this.allKeys.filter(i => i.required).map(i => i.apiKey)
      const inListKeys = data.filter(i => requiredKeys.includes(i.key))
      const notConfigedKeys = inListKeys.filter(i => 
        {
          const keysItem = this.allKeys.find(a => a.apiKey === i.key)

          if (keysItem && keysItem.apiTextKey) {
            return !i.value && !i.text
          } else {
            return !i.value
          }
        }
      )
      let illegalKeys = []
      if (notConfigedKeys.length) {
        illegalKeys = illegalKeys.concat(notConfigedKeys.map(i => i.describe))
      }

      return illegalKeys
    },
    async saveAndPrint() {
      if (!this.templateId) {
        this.$message.error(`请先选择标签模板`)
        return
      }
      const validate = this.requiredValidate()
      if (validate) return
      const {
        auth_type
      } = this.user
      if (auth_type === 2) {
        const confirm = await this.$utils.printWarningConfirm(`将消耗打印可用标签数量，是否继续操作？`)
        
        if (!confirm) return 
      }

      const saved = await this.save()
      if (saved) {
        this.printTemplate()
      }
    },
    save() {
      let newData = []
      this.allTagContent.forEach(item=>{
        let content = this.tagContentPublic.concat(item.data,this.tagContentText)
        let info = {
          tag_id: this.templateId,
          num: item.printNum,
          content:JSON.stringify(content),
          print_uid: this.printUser,
          print_name: this.printUserName,
          platform: 1 // 打印渠道
        }
        let detail = {}
        content.forEach(i => {
          if (i.type !== 'list') {
            detail[i.key] = i.value
            const keysItem = this.allKeys.find(a => a.apiKey === i.key)
            const apiTextKey = keysItem ? keysItem['apiTextKey'] : ''
            if (apiTextKey && i.text) {
              detail[apiTextKey] = i.text
            }
          }
        })
        const params = Object.assign({}, detail, info)
        newData.push(params)
      })
      return this.$request('post', saveMultiple, newData)
      .then(res => {
        if (res && res.serial_number) {
          this.saveData = res.serial_number
        }

        return !!res
      })
    },
    async printTemplate() {
      const promises = this.allTagContent.map(async (item,index)=>{
        const detail = {
          size: this.size,
          content: JSON.stringify(this.tagContentPublic.concat(item.data,this.tagContentText))
        }
        const ins_code = new Array(Number(item.printNum)).fill({})
        const printData = this._parseSmartTagConfigByDetail(detail)

        // 如果有logo时处理
        const { tenant_id } = this.templateDetail
        const { tag } = printData
        let { content } = tag
        content = await this._setLogoByData(content, tenant_id)
        // 如果有流水号，需要添加流水号
        content = this._setSerialNumber(content,this.saveData[index])
        // 如果有标签识别码
        content = this._labelIdenCode(content)
        printData.tag.content = content
        return this._generatePrintHtml(printData, { ins_code })
        
      })
      const results = await Promise.all(promises)
      let arrStr = [results.join('')]

      this.$utils.print(arrStr, 'smartTag')
    },
    getTagTemplates(name = undefined) {
      return this.$request('get', getTag, { name })
      .then(res => {
        this.templateOpts = res || []
      })
    },

    // 计算标签打印的总算
    handleChange(){
      let sum = 0
      this.$nextTick(()=>{
        this.allTagContent.forEach(item=>{
          sum += Number(item.printNum)
        })
        this.printSum = sum
      })
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 获取样式为layout-page的第一个元素的高度
    this.layoutPageHeight = document.querySelector('.layout-page').offsetHeight - 30;
    window.addEventListener('resize', function () {
      this.layoutPageHeight = document.querySelector('.layout-page').offsetHeight - 30;
      console.log('resize')
    });
  },
}
</script>

<style scoped lang="scss">
  @import '@/assets/css/common.scss';
  .row1{
    width: 100%;
  }
  .row2{
    width: 100%;
  }
  .box{
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  .box-item{
    display: flex;
    margin-bottom: 20px;
  }
  .row2-1{
    width: 70%;
  }
  .row2-2{
    width: 30%;
    height: 100%;
  }
  .value-item {
    width: 200px;
    height: 40px;
    line-height: 40px;
    border: 1px dashed lightgray;
    border-radius: 4px;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .print-box{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .icon {
    font-size: 40px;
  }
  .public-box{
    display: flex;
    align-items: center;
  }
  .model-title{
    margin-top: 10px;
  }
  .back-color{
    background: #fff;
    padding: 10px;
  }
  .line{
    width: 100%;
    height: 1px;
    background: #ccc;
    margin-bottom: 15px;
    margin-top: 10px;
  }
</style>